import CategoriesController from './categories-controller'

export default CategoriesController
